import { Component } from '@angular/core';

@Component({
    templateUrl: './main.component.html',
    styleUrls: [ './main.component.scss' ]
})
export class MainComponent {
}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/main.component.ts